import cuc from './config-cuc.json';
import univa from './config-univa.json';
import umad from './config-umad.json';
import piloto from './config-piloto.json';
import uao from './config-uao.json';

const env = process.env.REACT_APP_ENV || 'cuc';

const CONFIG = {
  cuc,
  univa,
  umad,
  piloto,
  uao,
};

export default CONFIG[env];
